'use client';

import { useDialog } from '../../hooks/useDialog';
import { DialogComponent } from './DialogComponent';

export function DialogContainer() {
  const { state } = useDialog();

  return (
    <DialogComponent
      isOpen={state.isOpen}
      onOpenChange={state.onOpenChange}
      title={state.title}
      message={state.message}
      confirmButtonText={state.confirmButtonText}
      cancelButtonText={state.cancelButtonText}
      onConfirm={state.onConfirm}
      onCancel={state.onCancel}
      showDeleteButton={state.showDeleteButton}
    />
  );
}
